var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#4FB1EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8141 18.8151V13.1845H5.18281C4.86893 13.1841 4.56883 13.0592 4.34688 12.8372C4.12492 12.6152 4.00042 12.3143 4 12.0004C4.00042 11.6865 4.12492 11.3855 4.34688 11.1635C4.56883 10.9416 4.86893 10.8167 5.18281 10.8162H10.8141V5.1865C10.8141 4.87222 10.939 4.57095 11.1609 4.34849C11.3829 4.12603 11.6842 4.00064 11.9984 4C12.3128 4.00064 12.6139 4.12586 12.8359 4.34849C13.0579 4.57112 13.183 4.87286 13.1828 5.18728V10.817H18.8156C19.1295 10.8174 19.4296 10.9423 19.6516 11.1643C19.8735 11.3863 19.9996 11.6872 20 12.0012C19.9996 12.3151 19.8735 12.616 19.6516 12.838C19.4296 13.06 19.1295 13.1849 18.8156 13.1853H13.1828V18.8158C13.1829 18.9714 13.1517 19.1253 13.0922 19.269C13.0327 19.4128 12.9459 19.5435 12.8359 19.6535C12.726 19.7634 12.5953 19.8507 12.4516 19.9101C12.3079 19.9696 12.154 20.0001 11.9984 20C11.8429 20.0001 11.6891 19.9693 11.5453 19.9098C11.4016 19.8502 11.2709 19.7631 11.1609 19.6531C11.051 19.543 10.9641 19.4125 10.9047 19.2686C10.8453 19.1248 10.8139 18.9707 10.8141 18.8151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/IconPlus.40726984.svg";
export { ForwardRef as ReactComponent };